/** Canonical route for Products & Services (Help & Resources). */
export const PRODUCTS_SERVICES_PATH = "/products";

/** Legacy route — redirects to {@link PRODUCTS_SERVICES_PATH}. */
export const PRODUCTS_SERVICES_LEGACY_PATH = "/other-details";
